export default {
  colors: {
    text: '#fff',
    background: '#000',
    primary: '#08f',
    secondary: '#f0f',
    darkgray: '#333'
  },
  styles: {
    pre: {
      color: 'secondary',
      bg: 'darkgray'
    },
    code: {
      color: 'secondary'
    }
  }
};